import React, { useContext } from "react";
import { addProjectFile } from "api/Projects";
import { CheckMarkIcon, PlusIcon } from "components/svg";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "components/ui/Modal";
import FileInput from "components/forms/FileInput";
import BasicButton from "components/forms/BasicButton";
import { useToast } from "components/toast";
import { trackActivity } from "api/ActivityTracker";
import UserContext from "context/User";


export default function FileUpload({
  title,
  afterUpload,
  project,
}: {
  title: string;
  project?: any;
  afterUpload?: () => void;
}) {
  const toast = useToast();
  const { user } = useContext<any>(UserContext);

  const [value, setValue] = React.useState<any>(null);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  async function _onSubmit() {
    if (value) {
      setIsSubmitting(true);
      await fetch(value.url, {
        method: "PUT",
        headers: { "Content-Type": value?.file?.type },
        body: value?.file,
      })
        .then(async (res: any) => {
          if (res.ok) {
            
            const payload = {
              url: value?.location,
              name: value?.file?.name,
            };

            console.log("Sending payload:", payload);

            const res = await addProjectFile({
              id: project.id,
              data: payload,
            });
            
            if (res?.id) {
              if (project?.id) {
                void trackActivity({
                  module: "projects",
                  action: "upload_project_file",
                  actionType: "create",
                  userId: user?.id || null,
                  companyId: user?.company?.id || null,
                  entityType: "project",
                  entityId: project.id,
                  metadata: {
                    fileId: res.id,
                    fileName: value?.file?.name ?? null,
                  },
                  userAgent: typeof navigator !== "undefined" ? navigator.userAgent : null,
                });
              }
              toast.add("File uploaded", "var(--theme-ui-colors-success)");
              setIsOpen(false);
              setValue(null);
              if (typeof afterUpload === "function") afterUpload();
            } else {
              toast.add(
                res?.message ? res.message : "Error uploading file",
                "var(--theme-ui-colors-danger)"
              );
            }
          }
        })
        .catch((err) => {
          toast.add("Error uploading file", "var(--theme-ui-colors-danger)");
        });
      setIsSubmitting(false);
    }
  }

  return (
    <>
      <BasicButton scheme="secondaryOutline" onClick={() => setIsOpen(!isOpen)}>
        <PlusIcon fill={"#000"} />
        {title}
      </BasicButton>
      <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} centered closeOnBackdropClick={false}>
        <ModalHeader toggle={() => setIsOpen(false)}></ModalHeader>
        <ModalBody>
          <FileInput
            directory={`projects/${project.id}/files`}
            onChange={(val: any) => {
              setValue(val[0]);
            }}
            refreshValue={isSubmitting}
            multiple={false}
          />
        </ModalBody>
        <ModalFooter>
          <BasicButton
            type="button"
            onClick={() => setIsOpen(false)}
            scheme="secondaryOutline"
          >
            Cancel
          </BasicButton>
          <BasicButton
            type="submit"
            onClick={_onSubmit}
            $submitting={isSubmitting}
            $iconHeight="14px"
            $iconWidth="14px"
            $loadingColor="#fff"
            keepText={true}
          >
            {!isSubmitting && <CheckMarkIcon fill={"#fff"} />}Add File
          </BasicButton>
        </ModalFooter>
      </Modal>
    </>
  );
}
